import axios from 'axios';
import {
  LocationPermitComplianceAddFormModel,
  LocationPermitComplianceModel,
  LocationPermitCompliancePage
} from 'app/edozvola/cases/location-permit-compliance/model/location-permit-compliance.model';

export const fetchLocationPermitCompliance = async ({ uuid, webId }): Promise<LocationPermitComplianceAddFormModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/location-permit-compliance/${ uuid }/${ webId }`)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

export const deleteLocationPermitCompliance = async (uuid, webId): Promise<LocationPermitComplianceAddFormModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/cases/location-permit-compliance/${uuid}/${webId}`)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

export const saveLocationPermitCompliance = async (
  uuid: string,
  locationPermitCompliance: LocationPermitComplianceAddFormModel,
): Promise<LocationPermitComplianceAddFormModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/cases/location-permit-compliance/${ uuid }`, locationPermitCompliance)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

export const fetchLocationPermitCompliancePage = async ({
                                                          signal,
                                                          pagination,
                                                          uuid
                                                        }): Promise<LocationPermitCompliancePage> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(
        `api/cases/location-permit-compliance/${ uuid }??page=${ pagination.page }&size=${ pagination.size }&column=${ pagination.column }&direction=${ pagination.direction }`,
        {
          signal: signal,
        },
      )
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.error);
      });
  });
};


export const fetchSavedLocationPermitCompliance = async ({
                                                           uuid,
                                                           idLocationPermitComplianceMap,
                                                         }): Promise<LocationPermitComplianceAddFormModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/location-permit-compliance/saved/${uuid}/${idLocationPermitComplianceMap}`)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

export const fetchLocationPermitComplianceData = async ({ uuid }): Promise<LocationPermitComplianceModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/location-permit-compliance/data/${uuid}`)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

export const saveLocationPermitComplianceData = async (
  uuid: string,
  locationPermitComplianceData: LocationPermitComplianceModel,
): Promise<LocationPermitComplianceModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/cases/location-permit-compliance/data/${uuid}`, locationPermitComplianceData)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

